module.exports = __webpack_public_path__ + "static/media/authImg.ae552b1d.png";